import React, { useEffect, useState } from 'react'
import BackArrowTransparent from '../svg/back-arrow-transparent'

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false)

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    // Button is displayed after scrolling for 500 pixels
    const toggleVisibility = () => {
      if (window.pageYOffset > 500) {
        setIsVisible(true)
      } else {
        setIsVisible(false)
      }
    }

    window.addEventListener('scroll', toggleVisibility)

    return () => window.removeEventListener('scroll', toggleVisibility)
  }, [])

  return (
    <div className='scrollTop'>
      {isVisible && (
        <div onClick={scrollToTop}>
          <BackArrowTransparent
            fill='var(--primary-color)'
            style={{ transform: 'rotate(90deg)' }}
          />
        </div>
      )}

      <style jsx>{`
        .scrollTop {
          position: fixed;
          bottom: 2rem;
          right: 2rem;
          align-items: center;
          height: 40px;
          justify-content: center;
          z-index: 1000;
          cursor: pointer;
          animation: fadeIn 0.3s;
          transition: opacity 0.4s;
          opacity: 1;

          :global(svg) {
            opacity: 1;
          }
        }

        .scrollTop:hover {
          opacity: 0.5;
        }

        @media (max-width: 1024px) {
          .scrollTop:hover {
            opacity: 1;
          }
        }

        @keyframes fadeIn {
          0% {
            opacity: 0;
          }
          100% {
            opacity: 1;
          }
        }
      `}</style>
    </div>
  )
}
